import {createApp} from 'vue'
import NewLoanCalculatorResultDesktop from './NewLoanCalculatorResultDesktop'

const el = '.nyk-component--new-loan-calculator-result-desktop'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((NewLoanCalculatorResultDesktopDOM)=>{
            const component = createApp(NewLoanCalculatorResultDesktop).use(Store)
            component.mount(NewLoanCalculatorResultDesktopDOM)
        })
    }
}